var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticStyle:{"padding":"200px 500px"}},[_c('a-alert',{attrs:{"message":"404路由不存在","description":"很抱歉你访问的地址或方法不存在","type":"warning","showIcon":""}}),_c('router-link',{attrs:{"to":"/"}},[_vm._v("回首页")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }